import { PlusCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import DialogLayout from "../../../components/dialog-layout";
import DialogFormComponent from "../../../components/form/dialog-form.component";
import { FormItem, FormType } from "../../../components/form/form-generator";
import ImageUploader from "../../../components/image-uploader";
import VideoUploader from "../../../components/video-uploader";
import {
  FileUploadCategory,
  uploadFile,
  uploadVideoFile,
} from "../../../services/file-upload.service";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { updateQuizard } from "../apis/quizard.api";
import { QuizardDetailsEntity } from "../entities/quizard-details.entity";
import { QuizardEditEntity } from "../entities/quizard-edit.entity";
import { QuizardEditModel } from "../models/quizard-edit.model";

const formElements: FormItem[] = [
  {
    title: "Title",
    contentKey: "title",
    type: FormType.text,
  },
  {
    title: "Description",
    contentKey: "description",
    type: FormType.textArea,
  },
  {
    title: "Type",
    contentKey: "type",
    type: FormType.dropdown,
    options: [
      {
        id: "Test",
        value: "Test",
      },
    ],
  },
];

export default function EditQuizardDialog({
  open,
  setOpen,
  quizard,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  quizard: QuizardDetailsEntity;
}) {
  const setAlert = useDashboardStore((state) => state.setAlert);
  const [imageFile, setImageFile] = useState<File>();
  const [videoFile, setVideoFile] = useState<File>();

  const onSave = async (values: QuizardEditEntity) => {
    if (imageFile) {
      values.imageName = await uploadFile(
        imageFile,
        FileUploadCategory.QUIZARD
      );
    }

    if (videoFile) {
      values.videoName = await uploadVideoFile(
        videoFile,
        FileUploadCategory.QUIZARD_VIDEO
      );
    }

    updateQuizard(QuizardEditModel.fromEntity(values))
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        setAlert({
          message: error.response.data.message,
          type: AlertType.error,
        });
      });
  };

  return (
    <DialogLayout
      title="Edit Quizard"
      open={open}
      setOpen={setOpen}
      Icon={PlusCircleIcon}
    >
      <div className="mt-6">
        <ImageUploader
          id="coverImage"
          label="Cover Image"
          setImageFile={setImageFile}
          previewUrl={quizard.imageUrl}
        />
        <VideoUploader
          id="introImage"
          label="Intro Video"
          setVideoFile={setVideoFile}
        />
        <DialogFormComponent
          elements={formElements}
          content={QuizardEditEntity.fromDetailsEntity(quizard)}
          onClickSubmit={onSave}
          submitButtonTitle="Create"
          onClickCancel={() => setOpen(false)}
        />
      </div>
    </DialogLayout>
  );
}
